var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "wizard-summary" }, [
    _c("section", { staticClass: "wizard-summary__head" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "link--go-back",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.goBack("top")
            }
          }
        },
        [_vm._v("\n      Go Back\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "wizard-summary__body" }, [
      _vm.isWizardDataAvailable
        ? _c("div", { staticClass: "body__content" }, [
            _c("div", { staticClass: "wizard-summary__flex" }, [
              _c("div", { staticClass: "wizard-summary__flex--left" }, [
                _c("p", [
                  _vm._v(
                    "\n            If you need to change any of your selections,\n            "
                  ),
                  _c("strong", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goBack("link")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "go back to Step 1 of\n            'Help Me Choose a Platform'"
                        )
                      ]
                    )
                  ]),
                  _vm._v(
                    ".\n            To see which platforms are most compatible with your selections, click\n            "
                  ),
                  _c("strong", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.beginWizardFiltering("link")
                          }
                        }
                      },
                      [_vm._v("see your results")]
                    )
                  ]),
                  _vm._v(".\n          ")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wizard-summary__flex--right" },
                [
                  _c(
                    "unum-button",
                    {
                      nativeOn: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.beginWizardFiltering("button")
                        }
                      }
                    },
                    [_vm._v("\n            See Your Results\n          ")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-wrapper",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleClick($event)
                  }
                }
              },
              [
                _c("table", { staticClass: "summary-table" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [
                        _vm._v("Do you need support for core benefits?")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.wizardAnswers.core_benefits ? "Yes" : "No")
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("What products will you be offering?")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm._l(_vm.wizardAnswers.products, function(
                            product,
                            prodKey
                          ) {
                            return [
                              !!product.supported
                                ? _c(
                                    "div",
                                    {
                                      key: prodKey,
                                      staticClass: "product-offered"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "wizard-summary__product"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.prodNameLookup(prodKey)
                                            ) + " Insurance"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      product.standAlonePoliciesSupported ||
                                      product.stackedCoverageSupported
                                        ? _c("ul", [
                                            product.standAlonePoliciesSupported
                                              ? _c("li", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          product.standAlonePoliciesSupported
                                                            ? "With"
                                                            : "No"
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    "\n                        Stand Alone Policies\n                      "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            product.stackedCoverageSupported
                                              ? _c("li", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          product.stackedCoverageSupported
                                                            ? "With"
                                                            : "No"
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    "\n                        Stacked Coverage\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("Will there be employer paid products?")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.wizardAnswers.employerPaidSupport ? "Yes" : "No"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "Will 75% of your employees be seen or spoken to?"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.wizardAnswers.employee_75_seen_spoken
                              ? "Yes"
                              : "No"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm.wizardAnswers.employee_75_seen_spoken
                          ? _c("p", [
                              _vm._v(
                                "\n                  You may qualify for the POPS Program with specific platforms.\n                  Email:\n                  "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "mailto:PartnerManagement@ColonialLife.com"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.logEvent(
                                        "clicked_wizard_summary_partnermanagement@coloniallife.com_link"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    PartnerManagement@ColonialLife.com\n                  "
                                  )
                                ]
                              )
                            ])
                          : _c("p", [
                              _vm._v(
                                "\n                  If 75% of your employees are seen or spoken to, you may qualify for the POPS Program with specific platforms.\n                  Email:\n                  "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "mailto:PartnerManagement@ColonialLife.com"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.logEvent(
                                        "clicked_wizard_summary_partnermanagement@coloniallife.com_link"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    PartnerManagement@ColonialLife.com\n                  "
                                  )
                                ]
                              )
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("How do you plan to enroll?")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm._l(_vm.wizardAnswers.features, function(
                            feature,
                            featureKey
                          ) {
                            return [
                              !!feature.available
                                ? _c("p", { key: featureKey }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          featureKey.split("_").join(" ")
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm.wizardAnswers.features.auto_census_enroll.available
                          ? _c("p", [
                              _vm._v(
                                "\n                  For more information on extended timing, refer to the Underwriting CARES Team:\n                  "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:uwCaresTeamCol@unum.com"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.logEvent(
                                        "clicked_wizard_summary_uwcaresteamcol@unum.com_link"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("uwCaresTeamCol@unum.com")]
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Who will be building the case?")]),
                      _vm._v(" "),
                      _c("td", [
                        !!_vm.wizardAnswers.buildCaseColonialLifeOffice
                          ? _c("p", [
                              _vm._v(
                                "\n                  Broker / Coordinator\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !!_vm.wizardAnswers.buildCaseBrokerIntegratedPartner
                          ? _c("p", [
                              _vm._v(
                                "\n                  System / Vendor\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !!!_vm.wizardAnswers.buildCaseBrokerIntegratedPartner &&
                        !!!_vm.wizardAnswers.buildCaseColonialLifeOffice
                          ? _c("p", [
                              _vm._v(
                                "\n                  Either Broker / Coordinator "
                              ),
                              _c("strong", [_vm._v("OR")]),
                              _vm._v(" System / Vendor\n                ")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ])
                  ])
                ])
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("span", { staticClass: "mobile-hide" }, [
        _vm._v("Help Me Choose a Platform - ")
      ]),
      _vm._v("Summary")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Question")]),
        _vm._v(" "),
        _c("th", [_vm._v("Answer")]),
        _vm._v(" "),
        _c("th", [_vm._v("Notes")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fbbca3b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fbbca3b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WizardSummary.vue
// module id = null
// module chunks = 